/**
 * RR Cart Drawer — JS
 * Reordena aleatoriamente las cards de recomendaciones en cada apertura del drawer.
 */

function shuffleRRRecs() {
  const grid = document.querySelector('.rr-cart-recs__grid');
  if (!grid) return;
  const cards = Array.from(grid.children);
  // Fisher-Yates shuffle
  for (let i = cards.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    grid.appendChild(cards[j]);
    cards.splice(j, 1);
  }
}

// Ejecutar al abrir el drawer
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('cart-drawer-component');
  if (!drawer) return;

  drawer.addEventListener('dialog-open', shuffleRRRecs);

  // También al agregar al carrito (el drawer se abre automáticamente)
  document.addEventListener('cart:add', shuffleRRRecs);
});
